<template>
  <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
    <div class="container">
      <h2 class="fsize32 text4F0A4B text-left capitalize">
        <b>History</b> of Palliative Care In India
      </h2>
      <p class="fsize16 text-dark mt-4">
        In India, the earliest facilities to deliver palliative care within
        cancer centers were established in some places like Ahmedabad,
        Bangalore, Mumbai, Trivandrum, and Delhi in the late 1980s and the early
        1990s. Palliative Care was initiated in Gujarat in 1980s with the
        opening of a pain clinic and palliative care service under the
        department of Anesthesiology at Gujarat Cancer and Research Institute
        (GC and RI) a Regional Cancer Centre in Western India. One of the
        important steps in the history of palliative care development in India
        was also began from here; forming of Indian Association of Palliative
        Care (IAPC). In 1986, Professor D’Souza opened the first hospice, Shanti
        Avedna Ashram, in Mumbai, Maharashtra, Central India. At a similar time,
        pain clinics were established at the Regional Cancer Centre, Trivandrum,
        Kerala, with the assistance of a WHO subsidy, and at Kidwai Memorial
        Institute of Oncology, Bangalore, Karnataka. From the 1990s onwards,
        there was a significant increase in the momentum of development of
        hospice and palliative care provision. This was demonstrated through
        both an expansion in the number of services as well as other key events
        and initiatives. Can Support was founded in 1997 in Delhi which provided
        the first free palliative care home care support service in North India.
        In Pune, Maharashtra, central India, the Cipla Cancer Palliative Care
        Centre was established. The IAPC was registered as Public Trust and
        Society in March 1994 in Ahmedabad. IAPC held its first international
        conference at Varanasi in January 1994 (with the assistance of WHO and
        Government of India) and adopted a constitution. The following year, the
        IAPC set up a Palliative Care Drugs Committee and Educational Task Force
        and held its Second International Conference in Ahmedabad, where 180
        delegates attended. Morphine availability was a considerable problem to
        the provision of hospice and palliative care. The Narcotic Substances
        and Psychotropic Substances (NDPS) act of India brought out in 1985 made
        procurement of morphine so difficult and had a negative impact such that
        use of morphine in the country dropped steeply in succeeding years. 
      </p>
      <div class="mt-10 mx-auto w-11/12 lg:flex md:flex">
        <div class="lg:w-4/12 md:w-3/12 w-full">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India1.jpg"
            alt="history of palliative in india 1"
            class="history-img object-cover"
          />
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India2.jpg"
            alt="history of palliative in india 2"
            class="history2-img object-cover"
          />
        </div>
        <div class="lg:w-8/12 md:w-9/12 w-full lg:px-10">
          <div class="lg:flex md:flex gap-8">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India3.jpg"
              alt="history of palliative in india 3"
              class="history4-img object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India4.jpg"
              alt="history of palliative in india 4"
              class="history3-img object-cover"
            />
          </div>
          <div class="lg:flex md:flex gap-8">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India5.jpg"
              alt="history of palliative in india 5"
              class="history5-img object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/palliative-care/History%20of%20Palliative%20Care%20In%20India6.jpg"
              alt="history of palliative in india 6"
              class="history6-img object-cover"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.history-img {
  border-radius: 40px 0px 40px 40px;
  height: 250px;
  width: 100%;
  margin: 0px auto;
}
.history2-img {
  border-radius: 40px 0px 40px 40px;
  height: 180px;
  width: 70%;
  margin: 40px 0px 0px auto;
}
.history3-img {
  border-radius: 40px 40px 0px 40px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history4-img {
  border-radius: 40px 40px 40px 0px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history5-img {
  border-radius: 0px 40px 40px 40px;
  height: 250px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history6-img {
  border-radius: 0px 40px 40px 40px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
@media (max-width: 640px) {
  .history-img {
    width: 100% !important;
  }
  .history2-img {
    width: 100% !important;
  }
  .history3-img {
    width: 100% !important;
  }
  .history4-img {
    width: 100% !important;
  }
  .history5-img {
    width: 100% !important;
  }
  .history6-img {
    width: 100% !important;
  }
}
</style>
